import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import DateSelection from "@/components/dateSelection";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { InputTheme, TableListTheme } from "@/styles/mui/tableListTheme";
import DownloadIcon from "@mui/icons-material/Download";
import { ThemeProvider } from "@mui/material/styles";

// Mui
import ImageZoom from "@/components/imageZoom";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";

import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

// Navigate
import { useLocation, useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Zoom Images
import "react-medium-image-zoom/dist/styles.css";

// Fetch
import { getRefundRecord } from "@/fetch/fetchRefund";
import { getAllWorkLocation } from "@/fetch/fetchWork";

// Config
import { exportCSVFile } from "@/config/csvConfig";
import { RefundTableColumn } from "@/config/tableColumnConfig";

import { useCurrentAction } from "@/hooks/user";
import { useSelector } from "react-redux";

const RefundPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  // States

  const [workLocationData, setWorkLocationData] = React.useState([]);
  const [selectedShop, setSelectedShop] = React.useState(0);
  const [refundData, setRefundData] = React.useState([]);
  const [imagesList, setImagesList] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const defaultStartDate = moment().startOf("month");
  const defaultEndDate = moment().endOf("month");

  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  const handleDownloadCsv = () => {
    const tempArr = [...refundData];
    var headers = {
      full_name: "full_name".replace(/,/g, ""),
      item_name: "item_name",
      refund_date: "refund_date",
      refund_qty: "refund_qty",
      invoice_created: "invoice_created",
    };

    for (let i = 0; i < tempArr.length; i++) {
      delete tempArr[i].id;
      delete tempArr[i].attachments;
      delete tempArr[i].giveaway_master_item_id;
      tempArr[i].invoice_created = moment(tempArr[i].invoice_created).format(
        "YYYY-MM-DD"
      );
      if (tempArr[i].refund_date !== null) {
        tempArr[i].refund_date = moment(tempArr[i].refund_date).format(
          "YYYY-MM-DD"
        );
      }
    }

    exportCSVFile(
      headers,
      tempArr,
      `Refund List - ${moment(startDate).format("YYYY-MM-DD")} to ${moment(
        endDate
      ).format("YYYY-MM-DD")} `
    );
  };

  const handleOnChangeShop = (shop) => {
    setSelectedShop(shop === null ? 0 : shop.id);
  };
  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);

      await getAllWorkLocation(true).then((data) => {
        if (data && data.results) {
          setWorkLocationData(data.data);
        }
      });
      await getRefundRecord(selectedShop, startDate, endDate).then((data) => {
        if (data && data.results) {
          setRefundData(data.data);
        } else {
          setRefundData([]);
        }
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  const onCellClick = async (data) => {
    if (Object.entries(data.row.attachments).length > 0) {
      let urls = [];
      // eslint-disable-next-line  no-unused-vars
      for (const [key, value] of Object.entries(data.row.attachments)) {
        urls.push(`${value}`);
      }
      setImagesList(urls);
    } else {
      setImagesList([]);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedShop, startDate, endDate]);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="StaffManagePage"
      selectedIndex={9}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`退貨查詢`}
        history={() => navigate(-1)}
        children={
          actions?.download ? (
            <IconButton
              component="label"
              onClick={() => handleDownloadCsv()}
              disabled={refundData.length > 0 ? false : true}
            >
              <DownloadIcon />
            </IconButton>
          ) : null
        }
      />
      <StyledPaper page={"yes"} alignItems="left">
        <Grid container spacing={2}>
          <ThemeProvider theme={InputTheme}>
            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <Autocomplete
                fullWidth
                options={workLocationData}
                autoComplete
                id="work-select"
                name="work"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, data) => {
                  handleOnChangeShop(data);
                }}
                getOptionLabel={(option) => option.work_shortcode}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.work_name} ({option.work_shortcode})
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="選擇店鋪"
                    sx={{ width: "100%" }}
                  />
                )}
              />
            </Grid>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
              xs={12}
              md={4}
              lg={4}
            ></DateSelection>
          </ThemeProvider>
        </Grid>
      </StyledPaper>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={refundData ? refundData : []}
            columns={RefundTableColumn}
            pageSize={25}
            onCellClick={(data) => onCellClick(data)}
          />
        </ThemeProvider>
        {/* <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" colSpan={6}>
                  退貨清單
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>經手人</TableCell>
                <TableCell>退貨名稱</TableCell>
                <TableCell align="right">退貨數量</TableCell>
                <TableCell align="center">退貨總數</TableCell>
                <TableCell align="center">檢查圖片</TableCell>
                <TableCell align="center">建立日期</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsData &&
                rowsData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell>{data.full_name}</TableCell>
                    <TableCell>{data.item_name}</TableCell>
                    <TableCell align="right">{data.refund_qty}</TableCell>

                    <TableCell align="center">{data.refund_total}</TableCell>

                    <TableCell align="center">
                      <IconButton onClick={() => loadImages(data.attachments)}>
                        <ZoomInIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell align="center">
                      {moment(data.time_created).format("YYYY-MM-DD H:mm:ss")}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer> */}
      </StyledPaper>
      {imagesList.length > 0 && (
        <StyledPaper page={"yes"}>
          <ImageZoom attachments={imagesList}></ImageZoom>
        </StyledPaper>
      )}
    </Layout>
  );
};

export default RefundPage;
